import type { MouseEventProps, UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Handle } from '@gik/ui/SvgIcon/GikIcons/Handle';
import React from 'react';
import type { Color } from 'react-color';

export type IColorHandleProps = {
  color: Color;
  active: boolean;
} & UIComponent &
  MouseEventProps;

export function ColorHandle({ color, active, className, ...otherProps }: IColorHandleProps) {
  const bem = useBemCN('color-handle');

  return (
    <div {...bem(null, [{ active }], className)} {...otherProps}>
      <Handle size={32} color={color?.toString()} />
    </div>
  );
}
